export default __webpack_public_path__ + "static/media/banner-preview-phone.58a10cf9.png";